/**
 * The four dimensions a match is scored against, and the token that carries
 * each one's color.
 *
 * 00-foundations section 1: the dimension colors are fixed and carry meaning,
 * so a dimension keeps its color on every surface that shows it and the member
 * learns the mapping once. That only holds if there is one list.
 *
 * The color is a CSS custom property, not a literal. Two components had their
 * own copy of these four as rgba literals and the copies had already drifted
 * from the token values: interests was rgba(109, 147, 46) against the design
 * set's #53702e.
 *
 * `scoreKey` is the field on an occupation or pathway card, so a caller reads
 * the score without a second mapping of its own.
 */
export interface MatchDimension {
  name: string;
  colorToken: string;
  scoreKey:
    | 'skillsMatchQualityId'
    | 'lifestyleMatchQualityId'
    | 'interestsMatchQualityId'
    | 'valuesMatchQualityId';
}

export const MATCH_DIMENSIONS: MatchDimension[] = [
  {
    name: 'Skills',
    colorToken: 'var(--m-skills)',
    scoreKey: 'skillsMatchQualityId'
  },
  {
    name: 'Lifestyle',
    colorToken: 'var(--m-lifestyle)',
    scoreKey: 'lifestyleMatchQualityId'
  },
  {
    name: 'Interests',
    colorToken: 'var(--m-interests)',
    scoreKey: 'interestsMatchQualityId'
  },
  {
    name: 'Values',
    colorToken: 'var(--m-values)',
    scoreKey: 'valuesMatchQualityId'
  }
];
